<div class="title">
  <mat-icon>receipt</mat-icon>
  SOW Types
</div>
<div class="description">SELECT THE SOW TYPES TO FILTER BY</div>

<div class="options">
  <elements-filter-chip
    icon="receipt"
    [caption]="template.name"
    [selected]="isSelected(template)"
    *ngFor="let template of templates$ | async"
    (click)="isSelected(template) ? removeProduct(template) : addProduct(template)"
    [suffixIcon]="isSelected(template) ? 'close' : undefined"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
